import { render, staticRenderFns } from "./announCList.vue?vue&type=template&id=9cedec9a&"
import script from "./announCList.vue?vue&type=script&lang=js&"
export * from "./announCList.vue?vue&type=script&lang=js&"
import style0 from "./announCList.vue?vue&type=style&index=0&id=9cedec9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports